import { useLang } from "@/App";
import { all, pick } from "@/data/images";
import Hero from "@/components/Hero";
import { Reveal, Pretitulo } from "@/components/Reveal";

export default function Cookies() {
  const { t } = useLang();
  const p = t.cookies;
  return (
    <div data-testid="pagina-cookies">
      <Hero pre={p.hero.pre} titulo={p.hero.titulo} fotos={[pick(p.hero.foto[0], 0) || all(p.hero.foto[0])[0]]} testid="hero-cookies" />
      <section className="py-20 md:py-28" data-testid="ck-intro">
        <div className="mx-auto max-w-2xl px-6 text-center md:px-10">
          <Reveal>
            <Pretitulo>{p.pre}</Pretitulo>
            <h2 className="mt-4 font-serif text-3xl font-light tracking-tight text-ink md:text-4xl">{p.titulo}</h2>
            <p className="mt-7 text-[15px] leading-relaxed text-ink-soft">{p.cuerpo}</p>
          </Reveal>
        </div>
      </section>
      <section className="pb-20 md:pb-28" data-testid="ck-contenido">
        <div className="mx-auto max-w-3xl px-6 md:px-10">
          {p.secciones.map((s, i) => (
            <Reveal key={s.t} delay={Math.min(i * 0.02, 0.2)} className="border-b border-lineas py-9 first:border-t" testid={`ck-seccion-${i + 1}`}>
              <h3 className="font-serif text-2xl font-light text-ink">{s.t}</h3>
              {s.p.map((par, j) => (
                <p key={j} className="mt-4 text-[14.5px] leading-relaxed text-ink-soft">{par}</p>
              ))}
              {s.lista && (
                <ul className="mt-4 list-disc space-y-2.5 pl-5">
                  {s.lista.map((li, j) => (
                    <li key={j} className="text-[14px] leading-relaxed text-ink-soft">{li}</li>
                  ))}
                </ul>
              )}
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}